<template lang="pug">
    div
        .container-loading.is-loading(v-if="volumeAlert.isLoading")
            .content
            .stripe.long-stripe.category
            .stripe.medium-long-stripe.category
            .stripe.long-stripe.category
            .stripe.medium-long-stripe.category

        .info-content(v-else-if="audienceHasVolumeAlert")
            .info-block
                .label Email
                .value {{ volumeAlert.details.email_audience_limit }}
            .info-block(v-if="volumeAlert.details.email_cc_audience_limit !== null")
                .label Email Cc
                .value.email-cc {{ displayVolumeAlertEmailCc }}
            .info-block(v-if="volumeAlert.details.below_limit !== null")
                .label Below
                .value {{ formatFigures(volumeAlert.details.below_limit) }}
            .info-block(v-if="volumeAlert.details.above_limit !== null")
                .label Above
                .value {{ formatFigures(volumeAlert.details.above_limit) }}
        .info-block(v-else)
            button.btn--xsmall.btn-add(@click="displayEditFormVolumeAlert()" :class="{ 'ui-disabled': !monitoringActionAllowed() }") create volume alert
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { isEmpty } from 'lodash'
import { formatNumber } from '@/utils/helpers'

export default {
    props: {
        volumeAlert: {
            type: Object,
            required: true
        }
    },

    computed: {
        audienceHasVolumeAlert() {
            return !isEmpty(this.volumeAlert.details)
        },
        displayVolumeAlertEmailCc() {
            return this.volumeAlert.details.email_cc_audience_limit === '[]' || this.volumeAlert.details.email_cc_audience_limit === ''
                ? '-'
                : this.volumeAlert.details.email_cc_audience_limit.replaceAll(',', ', ')
        },
        monitoringActionAllowed() {
            return this.getIsMonitoringActionAllowed()
        }
    },

    methods: {
        ...mapGetters('account', ['getIsMonitoringActionAllowed']),
        ...mapMutations('ui/volumeAlert', ['setShowVolumeAlertForm', 'setIsEditVolumeAlert']),
        formatFigures(figure) {
            return formatNumber(figure)
        },
        displayEditFormVolumeAlert() {
            this.setIsEditVolumeAlert({ isEdit: false })
            this.setShowVolumeAlertForm({ show: true })
        }
    }
}
</script>
